import React from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import CustomDialog, { CustomDialogProps } from "../../../components/Dialog/CustomDialog";
import { ProductContext } from "../../../contexts/ProductContext";
import ProductSampleAddForm from "./ProductSampleAddForm";
import ProductReferenceResponse from "../../../api/models/ProductReferenceResponse";
import { ProductSuggestionInnerFormikProps } from "../DescriptionTab/models/ProductSuggestionForm/SuggestionForm";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    marginBottom: theme.spacing(5),
  },
}));

const ProductSampleAddDialog = (props: CustomDialogProps) => {
  const { open, onClose } = props;
  const classes = useStyles();

  const submitForm = (
    productReference: ProductReferenceResponse | null,
    updateProductReference: (newProductReference: ProductReferenceResponse | null) => void,
  ): void => {
    updateProductReference(productReference);
    onClose(true);
  };

  return (
    <ProductContext.Consumer>
      {(productContext) => {
        const { updateProductReference } = productContext;
        return (
          <CustomDialog fullWidth maxWidth="sm" onClose={() => onClose(false)} open={open}>
            <h2 className={classes.header}>ADD TESA PRODUCT</h2>
            <ProductSampleAddForm
              handleSubmit={(values: ProductSuggestionInnerFormikProps) => {
                submitForm(
                  {
                    nart: values.nartField.nart,
                    productName: values.productNameField.code,
                    baseProduct: values.baseProductField.code,
                  },
                  updateProductReference,
                );
              }}
            />
          </CustomDialog>
        );
      }}
    </ProductContext.Consumer>
  );
};

export default ProductSampleAddDialog;
